export const MIXPANEL_EVENT_PREFIX = 'Usage ';
